if (!customElements.get('ntw-hero-cta')) {
  customElements.define('ntw-hero-cta', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.hero = this.closest('.hero');
      this.link = this.querySelector('a');
      if (!this.hero || !this.link) return;
      // The CTA belongs to the hero: native links and the theme's page transition
      // keep it painted until the document leaves. Never hide it on a tap.
      window.addEventListener('pageshow', () => {
        // BFCache restores an already-painted hero without replaying the entrance.
        if (this.hasReady) this.dataset.state = 'ready';
        else this.reveal();
      }, { signal });
      this.breakpoint = matchMedia('(min-width: 750px)');
      this.breakpoint.addEventListener('change', () => this.reveal(), { signal });
      this.reveal();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.generation = (this.generation || 0) + 1;
    }
    async reveal() {
      const generation = this.generation = (this.generation || 0) + 1;
      // Responsive rechecks must not blink an already-visible CTA.
      if (!this.hasReady) this.dataset.state = 'pending';
      if (window.Shopify?.designMode) {this.dataset.state = 'ready'; return;}
      const domReady = document.readyState !== 'loading' ? Promise.resolve() : new Promise(resolve => document.addEventListener('DOMContentLoaded', resolve, {once:true}));
      const fontsReady = Promise.race([document.fonts?.ready || Promise.resolve(), new Promise(resolve => setTimeout(resolve, 1500))]);
      const media = [...this.hero.querySelectorAll('.hero__media-wrapper video, .hero__media-wrapper img')].filter(el => el.getBoundingClientRect().width > 0 && el.getBoundingClientRect().height > 0);
      await Promise.all([domReady, fontsReady, ...media.map(el => this.mediaReady(el))]);
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      if (this.isConnected && generation === this.generation) {this.hasReady = true; this.dataset.state = 'ready';}
    }
    mediaReady(media) {
      if (media.tagName === 'IMG') return media.decode().catch(() => {});
      return new Promise(resolve => {
        let finished = false;
        let frameHandle;
        const done = () => {
          if (finished) return;
          finished = true;
          clearTimeout(posterTimer);
          if (frameHandle !== undefined) media.cancelVideoFrameCallback?.(frameHandle);
          media.removeEventListener('loadeddata', loaded);
          media.removeEventListener('error', posterFallback);
          resolve();
        };
        const posterFallback = () => {
          if (!media.poster) return;
          const image = new Image();
          image.src = media.poster;
          image.decode().then(done).catch(() => {});
        };
        const loaded = () => {
          // Safari/low-power autoplay may be paused with a decoded first frame.
          if (!media.requestVideoFrameCallback || media.paused && media.readyState >= 2) done();
        };
        const posterTimer = setTimeout(posterFallback, 4000);
        if (media.requestVideoFrameCallback) frameHandle = media.requestVideoFrameCallback(done);
        media.addEventListener('loadeddata', loaded);
        media.addEventListener('error', posterFallback);
        if (media.readyState >= 2) loaded();
        if (media.error) posterFallback();
      });
    }
  });
}
